
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { LogMixin } from "@/plugins/error.ts";
import netFail from '@/views/exception/netFail.vue'
import AppVersionPopup from "@/views/login/components/AppVersionPopup.vue";
import { getStoreInfo } from '@/api/ccx'
import { getSyDictDataInfo } from '@/api/commonConfig'
import { getAppVersionOrReleasePath } from '@/api/login'
import { setCcxStore } from '@/views/information'

@Component({
  mixins: [LogMixin],
  components: { netFail, AppVersionPopup }
})
export default class App extends Vue {
  @Getter keepAlivePages!: string[]
  @Getter token!: string
  @Getter includedComponents: string[]
  @Action setIncludedComponents!: (val: string[]) => void;
  @Getter loading!: number
  @Getter companyId!: string
  @Getter userId!: string
  @Getter mobile!: string
  @Getter isMultiStore!: boolean
  include = []
  netError = false // 网络请求失败
  timer = null

  created() {
    // 获取原生状态栏高度
    this.$bridge.callHandler("getStatusBarHeight", {}, (height: any) => {
      console.log('getStatusBarHeight', height);
      const h = height ? Number(height) : 0
      this.$store.dispatch("setTopSafetyHeight", h);
    });

    // 获取原生导航条高度
    this.$bridge.callHandler("getSafeAreaHeight", {}, (height: any) => {
      const h = height ? Number(height) : 0;
      console.log('getSafeAreaHeight ***', height);
      if(h > 0) {
        document.documentElement.style.setProperty("--safe-area-bottom", h + "px");
        this.$store.dispatch("setBottomSafetyHeight", h);
      }
    });

    const whitelist = ['/userAgreement', '/privacyPolicy', '/jielongIntroDemo']
    // 白名单校验
    if (!whitelist.includes(window.location.pathname)) {
      // 如果用户已登录，进入工作台（判断是否选择了公司，没选进入公司选择）；否则进入登录页
      if (this.token) {
        if (this.companyId || this.isMultiStore) {
          this.$router.replace('/workbench')
        } else {
          this.$router.replace({ path: '/selectStore', query: { from: 'app' } })
        }
      } else {
        this.$router.replace('/login')
      }
    }

    this.$store.commit('CLEAR_LOADING')
    this.$log.setLog({
      file: 'App.vue',
      name: 'created方法',
      type: '进入页面'
    })
    this.include = this.includedComponents
    // this.addListener()
    // console.log('app created ***', this.$route.name, this.$route.query)
    this.companyId && getStoreInfo({ storeId: this.companyId }).then((res) => {
      // 缓存常常鲜微店信息
      setCcxStore(res?.data || {})
    })
    this.userId && this.dictList()
  }

  mounted () {
    // 检查版本更新
    this.checkAppVersion()
  }

  dictList () {
    let param = {
      dictTypeId: 'goodsH5Share'
    }
    getSyDictDataInfo(param).then(res => {
      this.$store.commit('SET_SFTP_URL', res.data[0].dataName)
    })
  }

  addListener () {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  }

  updateOnlineStatus(e: any) {
    // console.log('app updateOnlineStatus e.type', e.type, this.$route.name)
    if (e.type === 'offline' && (!this.$route.name || this.$route.name === 'ShopHome')) this.netError = true
  }

  reload () {
    this.$log.setLog({
      file: 'App.vue',
      name: 'reload方法',
      type: '函数执行'
    })
    // console.log('app reload ***', this.$route.name)
    if (this.$route.name) window.location.reload()
    else this.$router.replace('/shopHome')
  }

  // 检查版本更新
  checkAppVersion () {
    this.$bridge.callHandler("getAppVersion", {}, (appVersion: string) => {
      const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      const header = {
        platForm: isiOS ? '2' : '1', // 1:安卓 2:iOS
        appVersion
      }
      getAppVersionOrReleasePath(header).then((res: any) => {
        const { data = [] } = res
        if (data.length) {
          (this.$refs.appVersionPopupRef as any).showPopup(data[0])
        }
      })
    });
  }

  @Watch('includedComponents')
  changeInclude(val: string[]) {
      this.include = val
  }

  @Watch('$route')
  routeChange(to, from) {
      this.$log.setLog({
        file: 'App.vue',
        name: 'routeChange方法',
        type: '函数执行'
      })
      console.log('routeChange', this.$route.meta.permission)
      // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
      if (to.meta.keepAlive) {
          !this.include.includes(to.name) && this.include.push(to.name);
      }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是后退
      // 如果是后退：
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
          const index = this.include.indexOf(from.name);
          index !== -1 && this.include.splice(index, 1);
      }
      this.setIncludedComponents(this.include)
      // 首页，产业商城订单页面弹出签约华润弹框
      const showRoutes = ['ShopMallOrder','Mall']
      let params = { companyId: this.companyId, mobile: this.mobile }
      if(showRoutes.includes(to.name)) {
        this.$resultPopup.show({...params, routeName: to.name})
      }
      
      // 处理地址相关页面的 sessionStorage 清除逻辑
      // 从创建店铺或地址管理页面离开时，如果不是去地址选择页，则清除地址信息缓存
      const addressRelatedPages = ['/createStore', '/editAddress', '/editStoreAddress']
      if (addressRelatedPages.includes(from.path) && to.path !== '/addressMap') {
        console.log(`从${from.path}离开，清除地址信息缓存`)
        window.sessionStorage.removeItem('editStoreAddressInfo')
      }
  }

  @Watch('loading')
  loadingChange (val: number) {
    if (this.loading <= 0) {
      clearInterval(this.timer)
      console.log('调用原生清除动画')
      // 调用原生结束动画
      this.$bridge.callHandler('showLoadingAnimation', {show: '0'})
    } else {
      console.log('调用原生动画开启')
      // 调用原生开启动画
      this.$bridge.callHandler('showLoadingAnimation', {show: '1'})
      // 启用加载动画后30秒后不消失，强制取消动画
      this.timer = setInterval(() => {
        this.$store.commit('CLEAR_LOADING')
      }, 30000)
    }
  }
}
